/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Awake_Proud_Pig_BumpInputs */

const fr_awake_proud_pig_bump = /** @type {(inputs: Awake_Proud_Pig_BumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non renseigné`)
};

/**

* @param {Awake_Proud_Pig_BumpInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const awake_proud_pig_bump = /** @type {((inputs?: Awake_Proud_Pig_BumpInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Awake_Proud_Pig_BumpInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_awake_proud_pig_bump(inputs)
});